/**
 * Just like setTimeout but with a Promise. The returned Promise resolves after
 * the specified milliseconds.
 */
export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
